import { Navigate, useParams } from 'react-router-dom'
import { ROUTES } from '@utils/constants.js'

/** Detalhe de módulo legado → Jornada com módulo na URL. */
export function ModuloDetailPage() {
  const { moduloId } = useParams<{ moduloId: string }>()
  const dest = moduloId ? `${ROUTES.MODULOS}?modulo=${moduloId}` : ROUTES.MODULOS
  return <Navigate to={dest} replace />
}
